export default __webpack_public_path__ + "static/wellnet-4a4d711c68da25374784645f505b73bd.jpg";